import { render, staticRenderFns } from "./SignupCheckbox.vue?vue&type=template&id=1a2a358a&scoped=true&"
import script from "./SignupCheckbox.vue?vue&type=script&lang=js&"
export * from "./SignupCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SignupCheckbox.vue?vue&type=style&index=0&id=1a2a358a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a358a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VTooltip})
